export { default as useDashboardErrorViewTranslation } from './useDashboardErrorViewTranslation';
